module.exports = __webpack_public_path__ + "static/media/ic_dianzan.b4eb1512.svg";